import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";


const SwOffCanvas = ({
  show,
  onClose,
  title,                 // string (Drawer Title)
  placement = "end",     // start | end | top | bottom
  size,                  // undefined | "md" | "lg" | "xl"
  backdrop = "static",   // static | true | false
  keyboard = false,      // true | false (press escape to close)
  className = "",        // string (additional classes)
  footer,               
  children,             
  ...rest
}) => {
  const sizeClass = size ? `sw-offcanvas-${size}` : "";

  return (
    <Offcanvas
      show={show}
      onHide={onClose}
      placement={placement}
      backdrop={backdrop}
      keyboard={keyboard}
      className={`sw-offcanvas ${sizeClass} ${className}`}
      {...rest}
    >
      {title && (
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{title}</Offcanvas.Title>
        </Offcanvas.Header>
      )}

      <Offcanvas.Body>{children}</Offcanvas.Body>

      {footer && <div className="OffCanvasFooter">{footer}</div>}
    </Offcanvas>
  );
};

export default SwOffCanvas;
